module.exports = __webpack_public_path__ + "media/images/icons/icon_detail_white-05e843da2ab9be04757eaa8d56c5d807.svg";